import * as storage from './storage.utils';
import {ActivatedTimer, Timer} from '../interfaces/timer.interface';
import * as moment from 'moment';

export const DEFAULT_TIMERS: Timer[] = [
];

export const DEFAULT_TIMER: Timer = {
  name: '',
  hours: 0,
  minutes: 0,
  seconds: 0,
  totalMinutes: 0,
  active: false
};

export const DEFAULT_ACTIVATED_TIMER: Timer = {
  ...DEFAULT_TIMER,
  totalMinutes: 0,
  finishAt: new Date(),
  startedAt: new Date()
};

export function getTimers(): Timer[] {
  return storage.getItem('timers') || [];
}

export function setTimers(timers: Timer[]): void {
  storage.setItem('timers', timers);
}

export function createTimer(timer: Timer): void {
    const timers: Timer[] = getTimers();
    timers.push(timer);
    storage.setItem('timers', timers);
}

export function deleteTimer(timer: Timer): void {
  const timers = getTimers();
  const index = timers.findIndex(item => item._id === timer._id);
  timers.splice(index, 1);
  storage.setItem('timers', timers);
}

export function updateTimer(timer: Timer): void {
  const timers = getTimers();
  const index = timers.findIndex(item => item._id === timer._id);
  timers[index] = timer;
  storage.setItem('timers', timers);
}

export function getLeftTime(timer?: Timer): { isNegative: boolean, value: string } {
  if (!timer) {
    return {
      isNegative: false,
      value: ''
    };
  }
  const finishAt = moment(timer.finishAt);
  const now = moment();
  const duration = moment.duration(moment(finishAt).diff(now));
  return formatTime(duration);
}

export function formatTime(duration: any): { isNegative: boolean, value: string } {
  let hours = duration.hours();
  let minutes = duration.minutes();
  let seconds = duration.seconds();
  const strArr: string[] = [];
  let isNegative = false;

  if (`${hours}:${minutes}:${seconds}`.includes('-')) {
    isNegative = true;
  }
  if (hours < 0) { hours = hours * (-1); }
  if (minutes < 0) { minutes = minutes * (-1); }
  if (seconds < 0) { seconds = seconds * (-1); }

  if (hours > 0) {
    strArr.push(hours < 10 ? `0${hours}` : hours);
  }
  // if (minutes > 0) {
  strArr.push(minutes < 10 ? `0${minutes}` : minutes);
  // }
  // if (seconds > 0) {
  strArr.push(seconds < 10 ? `0${seconds}` : seconds);
  // }
  return {
    value: strArr.join(':'),
    isNegative
  };
}

export function getActivatedTimer(): Timer | undefined {
  return storage.getItem('activatedTimer');
}

export function setActivatedTimer(timer: Timer): void {
  storage.setItem('activatedTimer', timer);
}

export function stopTimer(): void {
  storage.deleteItem('activatedTimer');
}

export const hasActivatedTimer = (): boolean => {
  return getActivatedTimer() !== null;
};

export function timeToMinutes(timer: Timer): number {
  let total = 0;
  if (timer.hours > 0) { total = total + (timer.hours * 60); }
  if (timer.minutes > 0) { total = total + timer.minutes; }
  if (timer.seconds > 0) { total = total + (timer.seconds / 60); }
  return total;
}

export function updateTimerIndex(timers: Timer[]): void {
  storage.setItem('timers', timers);
}
